import { Link } from "react-router-dom";
import { Mail, MessageCircle } from "lucide-react";
import { CONTACT_EMAIL, NAV_LINKS, SERVICES, WHATSAPP_LINK, WHATSAPP_NUMBER } from "@/data/content";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-800 bg-[#020617]">
      <div className="max-w-6xl mx-auto px-6 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-8 rounded-lg bg-[#1d4ed8] border border-[#38bdf8]/40 flex items-center justify-center font-bold text-white font-mono-x text-sm">
              KX
            </div>
            <span className="font-bold text-lg tracking-wider text-white font-mono-x">KORANEX</span>
          </div>
          <p className="text-xs text-slate-400 leading-relaxed mb-4">
            Koranex — Des solutions numériques pensées pour faire grandir votre entreprise.
          </p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="inline-flex items-center gap-2 text-xs font-mono-x text-[#38bdf8] hover:text-white transition-colors"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp : {WHATSAPP_NUMBER}
          </a>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-email-link"
            className="mt-2 inline-flex items-center gap-2 text-xs font-mono-x text-[#38bdf8] hover:text-white transition-colors"
          >
            <Mail className="w-4 h-4" />
            {CONTACT_EMAIL}
          </a>
        </div>

        <div>
          <h3 className="text-xs font-mono-x uppercase tracking-widest text-white mb-4">Nos services</h3>
          <ul className="space-y-2 text-xs text-slate-400">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="hover:text-[#38bdf8] transition-colors">
                  {s.navLabel}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs font-mono-x uppercase tracking-widest text-white mb-4">Navigation</h3>
          <ul className="space-y-2 text-xs text-slate-400">
            {NAV_LINKS.filter((l) => ["/", "/realisations", "/a-propos", "/contact"].includes(l.to)).map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-nav-${l.to === "/" ? "accueil" : l.to.slice(1)}`} className="hover:text-[#38bdf8] transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs font-mono-x uppercase tracking-widest text-white mb-4">Informations</h3>
          <ul className="space-y-2 text-xs text-slate-400">
            <li>
              <Link to="/contact" data-testid="footer-contact-link" className="hover:text-[#38bdf8] transition-colors">
                Contact & devis gratuit
              </Link>
            </li>
            <li>
              <Link to="/politique-de-confidentialite" data-testid="footer-privacy-link" className="hover:text-[#38bdf8] transition-colors">
                Politique de confidentialité
              </Link>
            </li>
            <li>
              <Link to="/mentions-legales" data-testid="footer-legal-link" className="hover:text-[#38bdf8] transition-colors">
                Mentions légales
              </Link>
            </li>
            <li className="text-slate-500 pt-2">Service 100 % en ligne, où que vous soyez.</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-6xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] font-mono-x text-slate-500">
          <span>© {new Date().getFullYear()} Koranex. Tous droits réservés.</span>
          <span>Sites web · Applications mobiles · SEO · Maintenance</span>
        </div>
      </div>
    </footer>
  );
}
